import { render, staticRenderFns } from "./ExameCenterList.vue?vue&type=template&id=f24c29e2&"
import script from "./ExameCenterList.vue?vue&type=script&lang=js&"
export * from "./ExameCenterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports